import { SerializableObject } from '../../common-react/core';

import { CashOnDeliveryInfo } from './cash-on-delivery-info.do';
import { InsuranceInfo } from './insurance-info.do';
import { Label } from './label.do';

export enum ShipmentDeliveryServiceExtraID {
  HomeDelivery = 'HomeDelivery',
  PostOffice = 'PostOffice',
  Fragile = 'Fragile',
  CashOnDelivery = 'CashOnDelivery',
  Insurance = 'Insurance',
  RecipientVerifiesDelivery = 'RecipientVerifiesDelivery',
  DeliveryToRecipientOnly = 'DeliveryToRecipientOnly',
  DeliverToRecipientOnlyAndHomeDelivery = 'DeliverToRecipientOnlyAndHomeDelivery',
  RecipientPays = 'RecipientPays',
}

export class ShipmentDeliveryServiceExtra extends SerializableObject {
  public id: ShipmentDeliveryServiceExtraID;
  public priceAmount: number;
  /**
   * If false, then the Gross Amount can change depending on other information.
   * Example: Price of insurance differs depending on the amount insured.
   */
  public priceFixed: boolean;
  public labels?: Label[];
  public estimatedDeliveryMessage?: string;
  public includedInService: boolean;
  public options?: InsuranceInfo | CashOnDeliveryInfo;
  /** Whether this extra service is blocked for the current user context. */
  public blocked?: boolean;
  /** The requirement type that blocks this service, e.g. "RequiresAuthentication". */
  public requirements?: string;
  /** A user-facing message explaining why the service is blocked. */
  public requirementsMessage?: string;

  // tslint:disable-next-line:no-any
  public buildFromJSON(json: any): void {
    super.buildFromJSON(json);

    if (this.options) {
      switch (this.id) {
        case ShipmentDeliveryServiceExtraID.CashOnDelivery:
          if (this.options && !(this.options instanceof CashOnDeliveryInfo)) {
            this.options = new CashOnDeliveryInfo(this.options);
          }
          break;
        case ShipmentDeliveryServiceExtraID.Insurance:
          if (this.options && !(this.options instanceof InsuranceInfo)) {
            this.options = new InsuranceInfo(this.options);
          }
          break;
        default:
          break;
      }
    }
  }

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    switch (propertyName) {
      case 'options':
        if (propertyValue === null) {
          return undefined;
        }
        // NOTE: The options property uses double serialization on the backend.
        return typeof propertyValue === 'string' ? JSON.parse(propertyValue) : propertyValue;

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }

  public asRequestBodyPart(): ShipmentDeliveryServiceExtraRequestBodyPart {
    const formValue = this.clone() as ShipmentDeliveryServiceExtraRequestBodyPart;
    // NOTE: The options property uses double serialization on the backend.
    const serialziedOptions = this.options ? JSON.stringify(this.options) : undefined;
    (formValue as { options: unknown }).options = serialziedOptions;
    return formValue;
  }
}

export type ShipmentDeliveryServiceExtraRequestBodyPart = Omit<ShipmentDeliveryServiceExtra, 'options'> & { options: string };
